import React, { useState, useEffect } from 'react'

import AudioSpectrum from 'react-audio-spectrum'

export default ({ closeCallback, data }) => {
    const {
        category,
        modal,
        duration
    } = data

    const [timeRemaining, setTimeRemaining] = useState(duration || 60)
    const [hasMounted, setHasMounted] = useState(false)

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeRemaining(timeRemaining => {
                if (!timeRemaining) {
                    closeCallback()
                }

                return timeRemaining - 1
            })
        }, 1000)

        setTimeout(() => {
            setHasMounted(true)
        }, 1)

        return () => clearInterval(interval)
    }, [])

    return (
        <div className={`modal-inner ${hasMounted ? 'visible' : ''}`}>
            <figure>
                <h1>
                    {timeRemaining || 0}
                </h1>
            </figure>
            <div>
                <h2>
                    {category}
                </h2>
                {(modal.audio) ?
                    <React.Fragment>
                        <audio id="audio-element"
                            src={modal.audio}
                            autoPlay
                            crossOrigin={'anonymous'}
                        >
                        </audio>
                        <AudioSpectrum
                            id="audio-canvas"
                            height={200}
                            width={400}
                            audioId={'audio-element'}
                            capHeight={0}
                            meterWidth={2}
                            meterCount={512}
                            meterColor={[
                                { stop: 0, color: 'white' },
                                { stop: 0.5, color: 'white' },
                                { stop: 1, color: 'rgba(255,255,255,0.5)' }
                            ]}
                            gap={4}
                        />
                    </React.Fragment>
                    : modal.image ?
                        <img src={modal.image} className={'image'} />
                        : null}
                <h1 dangerouslySetInnerHTML={{ __html: modal.title }} />
                <div className="copy">
                    <p dangerouslySetInnerHTML={{ __html: modal.copy }} />
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-wellness.jsx